<template>
  <b-container class="p-5" >
    <div class="d-flex justify-content-center mx-auto pb-4" style="width: 100%; flex-wrap: wrap;" >
        <!-- <div style="margin-right: 5em;" v-if="isMobileDevice == false"></div>
        <span style="font-size: 32px; font-family: Quicksand-Bold;"> Invoice Analytics </span> 
        <invoice-filter style="width: 100px; margin-left: 1em;" @filter="selectFilter" />  -->
        <b-form-checkbox
          size="lg"
          id="ToggleAED"
          v-if="currency != 'AED'" 
          v-model="currencyAED"
          inline
          > 
          View in AED 
        </b-form-checkbox>
        <hr class="flex-break"/>
        <div class="my-3 business-input d-flex justify-content-center" v-click-outside="hideList">
          <date-range-picker
            :startDate="dateRange[0]"
            :endDate="dateRange[1]"
            type="due"
            :customRanges="ranges"
            @date-select="filterPayablesAnalyticsByDate"
          ></date-range-picker>
            <multiselect-dropdown   class=""
            style="width: 20rem !important; margin-left: 2rem;"
            v-if="objects"
            :options="objects" 
            @item-select="filterMerchants"/>
          <hr cass="flex-break"/>
        </div>
      </div>
      <b-row class="py-3" v-for="(rows,ind) in fields" :key="ind">
      <b-col :cols="isMobileDevice == true? '12': '3'" ><span style="font-size: 18px; font-family: Quicksand-Bold;">{{ analyticsFields[ind] }}</span></b-col>

      <b-col v-for="(field, index) in rows" :key="index" :cols="isMobileDevice == true? '6': '2'" >
         <custom-cards
        :field="field"
        :index="ind"
        :isMobileDevice="isMobileDevice"
        :formatTableCurrency ="formatTableCurrency(field.numeric, currency)"
        :formatThousands = "formatThousands(field.numeric)"
        :prorateddata = "getProrateddata(field.numeric, field.mapping)"
        :columns="isMobileDevice == true? '6': '3'" 
        :loading = loading
        ></custom-cards>
  </b-col>
  </b-row>
    <!-- <b-row class="justify-content-md-center">
      <apexchart
        type="polarArea"
        :series="chartValues"
        width="500"
        :options="options"
      />
    </b-row> -->
  </b-container>
</template>

<script>
import AnalyticsService from "@/services/analytics.service";
import CompaniesService from "@/services/companies.service";
import InvoiceFilter from "./components/InvoiceFilter.vue"
import DateRangePicker from "@/views/pages/companies/components/DateRangePicker.vue";
import { DateRanges, last_30_days, last_7_days, next_30_days } from '@/dateRanges.js'
import { DateTime } from "luxon";
import MultiselectDropdown from "../../../components/multiselect.dropdown.vue";
import customCards from "./components/customCards.vue";
export default {
  name: "nice",
  components: {
    InvoiceFilter,
    DateRangePicker,
    MultiselectDropdown,
    customCards,
  },
  data() {
    return {
      filter: "invoices",
      data: null,
      term: "All Merchants",
      tempTerm: '',
      debounce: null,
      objects: null,
      listVisible: false,
      currency: 'AED',
      currencyAED: false,
      total: 0,
      loading: true,
      merchant: null,
      isMobileDevice:false,
      dateRange: DateRanges['This Month'],
      diffDays:0,
      ranges: {
        'This Month' : DateRanges['This Month'],
        'Last Month' : DateRanges['Last Month'],
        'Last 30 Days': DateRanges['Last 30 Days'],
        'This Quarter': DateRanges['This Quarter'],
        'Last Quarter': DateRanges['Last Quarter'],
        'This Year' : DateRanges['This Year'],
        'Last Year' : DateRanges['Last Year'],
        'All Time': DateRanges['All Time']
      },
      fields: [
        [
          {
            title: "Merchants",
            numeric: 0,
            mapping: ["current","businesses_analytics", "merchants_count"],
            isCurrency: false,
          },
          {
            title: "Payers",
            numeric: 0,
            mapping: ["current","businesses_analytics", "payers_count"],
            isCurrency: false,
          },
          {
            title: "Buyers",
            numeric: 0,
            mapping: ["current","payers_count"],
            isCurrency: false,
          },
          {
            title: "Users",
            numeric: 0,
            mapping: ["current","users_count"],
            isCurrency: false,
          }
        ],
        [
          {
            title: "Invoices",
            numeric: 0,
            mapping:  ["current","invoices_analytics", "invoices_count"],
            isCurrency: false,
          },
          {
            title: "Invoice Volume",
            numeric: 0,
            mapping:  ["current","invoices_analytics",this.currencyAED ? "invoices_sum_AED":"invoices_sum"],
            isCurrency: true,
          }],
          [
          {
            title: "Payments",
            numeric: 0,
            mapping: ["current","payments_analytics","payments_count"],
            isCurrency: false,
          },
          {
            title: "Payment Volume",
            numeric: 0,
            mapping: ["current","payments_analytics", this.currencyAED ? "payments_sum_AED" : "payments_sum" ],
            isCurrency: true,
          },
          {
            title: "% Paid",
            numeric: 0,
            mapping: ["current","payments_analytics","percent_paid"],
            isCurrency: false,
            ispercent:true,
          },
          {
            title: "% Paid Volume",
            numeric: 0,
            mapping: ["current","payments_analytics", "percent_paid_volume"],
            isCurrency: false,
            ispercent:true,
          },
          ],
          [
          {
            title: "Payments (Kema)",
            numeric: 0,
            mapping: ["current","payments_analytics","payments_count_kema"],
            isCurrency: false,
          },
          {
            title: "Payment Volume (Kema)",
            numeric: 0,
            mapping: ["current","payments_analytics", this.currencyAED ? "payments_sum_kema_AED" : "payments_sum_kema"],
            isCurrency: true,
          },
          {
            title: "% Kema Paid",
            numeric: 0,
            mapping: ["current","payments_analytics","percent_kema_paid"],
            isCurrency: false,
            ispercent:true,
          },
          {
            title: "% Kema Paid Volume",
            numeric: 0,
            mapping: ["current","payments_analytics", "percent_kema_paid_volume"],
            isCurrency: false,
            ispercent:true,
          },
        ],[
        {
            title: "Emails Sent",
            numeric: 0,
            mapping:  ["current","invoices_analytics", "emails_sent"],
            isCurrency: false,
          },
          {
            title: "Emails Viewed",
            numeric: 0,
            mapping:  ["current","invoices_analytics", "emails_viewed"],
            isCurrency: false,
          },],[
          {
            title: "Buyers",
            numeric: 0,
            mapping: ["current","invoices_analytics", "buyers_count"],
            isCurrency: false,
          },
          
          {
            title: "Invoices Opened",
            numeric: 0,
            mapping:  ["current","invoices_analytics", "invoice_opened"],
            isCurrency: false,
          },
        ]
      ],
      analyticsFields:[
        'Business','Invoices','','','Emails',''
      ],
      chartData: {
        Due: {
          value: 0,
          mapping: ["current","invoices_analytics", "due_count"],
        },
        Overdue: {
          value: 0,
          mapping: ["current","invoices_analytics", "overdue_count"],
        },
        Paid: {
          value: 0,
          mapping: ["current","invoices_analytics", "paid_count"],
        },
        Settled: {
          value: 0,
          mapping: ["current","invoices_analytics", "settled_count"],
        },
      },
      options: {
        labels: ["Due", "Overdue", "Paid", "Settled"],
        fill: {
          opacity: 1,
        },
        stroke: {
          width: 1,
          colors: undefined,
        },
        yaxis: {
          show: false,
        },
        legend: {
          position: "bottom",
        },
        plotOptions: {
          polarArea: {
            rings: {
              strokeWidth: 0,
            },
            spokes: {
              strokeWidth: 0,
            },
          },
        },
        theme: {
          monochrome: {
            enabled: true,
            color: '#73f3a9',
            shadeTo: "light",
            shadeIntensity: 0.6,
          },
        },
      },
    };
  },
  created() {
    let regexp = /android|iphone|kindle|ipad/i; 
    this.isMobileDevice = regexp.test(navigator.userAgent); 
    // this.getAnalytics();
    CompaniesService.query({is_merchant: "True"})
    .then(({ count, data }) => {
      this.total = count;
      data.sort(function(a, b){
      if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
      if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
      return 0;
      })
      this.objects = data;
    })
    .catch(({ message }) => {
      this.error = "There was an error loading companies.";
    })
  },
  computed: {
    chartValues() {
        return Object.values(this.chartData).map(state => state.value);
    }
  },
  methods: {
    hideList() {
      this.listVisible = false;
    },
    showList() {
      this.$refs.business_input[0].focus();
      this.tempTerm = this.term;
      this.term = '';
      this.listVisible = true;
    },
    search() {
      // clearTimeout(this.debounce);

      // this.debounce = setTimeout(() => {
      let params = {};

      if (this.term) params.search = this.term;

      this.query(params);
      // }, 500);
    },
    query(params = {}) {
      if (this.term) params.search = this.term;
      params.is_merchant = "True";

      this.error = null;
      this.querying = true;

      CompaniesService.query(params)
        .then(({ count, data }) => {
          this.total = count;
          this.objects = data.map((item) => {
            return item;
          });
        })
        .catch(({ message }) => {
          this.error = "There was an error loading companies.";
        })
        .finally(() => {
          this.querying = false;
        });
    },
    filterMerchants(eventip){
      if(eventip == null){
        this.merchant =null;
        this.currency ='AED'
        this.getAnalytics();
      }
      else{
        if(eventip.length >0){
          this.term = eventip.map((item)=> item.name);
          let currencyArr = [...new Set(eventip.map((item)=> item.base_currency))];
          this.currency = currencyArr.length >1 ? 'AED': currencyArr[0]
          this.merchant = eventip.map((item)=> item.id);
          this.getAnalytics()
        }
      }
    },
    getAnalytics() {
      this.loading = true;
      this.currencyAED = false;

      let params = {}
      if (this.dateRange!== void 0) {
        let diffTime = Math.abs(new Date( this.dateRange[1] - new Date(this.dateRange[0])));
        this.diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))+1; 
        params = {
          "due_start": this.dateRange[0].toUTC().toString(),
          "due_end": this.dateRange[1].toUTC().toString(),
          "pre_end": this.dateRange[0].toUTC().toString(),
          "pre_start":this.dateRange[0].minus({days: this.diffDays}).toUTC().toString()
        }
      }
      if (this.filter!==null) {
        params = {
          ...params,
          "status": this.filter
        }
      }
      
      if (this.merchant) {
        params = {
          ...params,
          "id": this.merchant.join(',')
        }        
      }
      
      if (!this.merchant) {
        AnalyticsService.query(params)
        .then(({data}) => {
          this.data = data;
          if(data.current['noexchange'].length >0){
            this.$showAlert('Exchange rates are not available for '+ data.current['noexchange'].toString(),'danger');
          }
          this.applyFilter();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$showAlert("Something went wrong!",'danger');
        })
        .finally(() => {
          this.loading = false;
        });
      }
      else {
        AnalyticsService.get('merchants',params)
        .then(({data}) => {
          this.data.current["invoices_analytics"] = data.current["invoices_analytics"];
          this.data.current["payments_analytics"] = data.current["payments_analytics"];
          if(data.current['noexchange'].length >0){
            this.$showAlert("Exchange rates are not available for "+ data.current['noexchange'].toString() ,'danger');
          }
          this.applyFilter();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$showAlert("Something went wrong!" ,'danger');
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    applyFilter() {
      this.fields.map((row) => {
        row.map((field) => {
          field.numeric = field.mapping.reduce((object, property) => object[property] || 0, this.data)
        })
      });
    },
    filterPayablesAnalyticsByDate(date_range) {

      let { startDate, endDate } = date_range;
      if (typeof startDate === 'string') {
        startDate = DateTime.fromISO(startDate);
      }
      if (typeof endDate === 'string') {
        endDate = DateTime.fromISO(endDate);
      }

      this.dateRange = [startDate, endDate];
      this.getAnalytics(this.merchant)
    },
    formatThousands(amount) {
      const formattedAmount = new Intl.NumberFormat("en-US", { 
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(amount);

      let splitAmount = formattedAmount.split(".");
      return splitAmount[1] > 0 ? formattedAmount : splitAmount[0];  
    },
    formatTableCurrency(amount) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        notation:'compact'
      }).format(amount);
      let splitAmount = formattedAmount.split(".");
      return `
        <strong class="numeric"><span style="vertical-align: super; font-size: 12px; margin-right:5px; font-weight: 500; ">${this.currencyAED ? 'AED' : this.currency}</span>${splitAmount[1].length>2?formattedAmount:splitAmount[0]}<span style=" font-size: 12px; margin-right:5px; font-weight: 500; ">${splitAmount[1].length<=2?'.'+splitAmount[1]:''} </span></strong>
      `;
    },
    selectFilter(filter) {
      switch(filter.toLowerCase()) {
        case "all":
          this.filter = null;
          break;
        case "paid":
          this.filter = "paid";
          break;
        case "settled":
          this.filter = "settled";
          break;
        case "overdue":
          this.filter = "overdue";
          break;
        case "due":
          this.filter = "due";
          break;
        default:
          this.filter = null;
      };
      // this.fields[1][0].mapping[1] = `${this.filter}_count`;
      // this.fields[1][1].mapping[1] = `${this.filter}_sum`;
      // this.applyFilter();
      this.getAnalytics(this.merchant);
    },
    getProrateddata(value, field){
      if(this.data !== null && (field.includes('invoices_analytics') || field.includes('payments_analytics'))){
        let preveousValue = this.data['previous'][field[1]][field[2]]
        let prevProrate = (preveousValue/this.diffDays)
        let currProrate = (value/this.diffDays)
        let prorateValue=0
        let proratedata=0
        let diffTime = Math.abs(new Date( this.dateRange[0]) - new Date());
        let futdiffTime = Math.abs(new Date( this.dateRange[1]) - new Date());
        let prediffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))+1; 
        let futdiffdays = Math.floor(futdiffTime / (1000 * 60 * 60 * 24))+1; 
        let currentDT= new Date().getTime()
        var htmlstr=``
        if(currentDT > new Date(this.dateRange[0]).getTime() && currentDT < new Date(this.dateRange[1]).getTime() ){
          proratedata= Math.floor(((value/prediffDays )* futdiffdays)+value)
          prorateValue= Math.floor(((proratedata-preveousValue)/preveousValue)*100)
          if(preveousValue == 0){
            prorateValue = 0
          }
          if(prorateValue>0){
            htmlstr= `<span style=" color: #54b854;" class="value_hover" 
            v-b-tooltip.hover data-title="Expected to reach ${this.formatThousands(proratedata)}\n Up from ${this.formatThousands(preveousValue)}  in the previous period" > <i style="color:#54b854; font-size:12px;" class="material-icons">timeline</i> ${this.formatThousands(prorateValue)}% <i style="color:#54b854; font-size:16px;" class="material-icons">arrow_upward</i></span>`
          }
          else if(prorateValue< 0){
            htmlstr= `<span style=" color: #ee7474;" class="value_hover" data-title="Expected to reach ${this.formatThousands(proratedata)}\n Down from ${this.formatThousands(preveousValue)}  in the previous period" > <i style="color:#ee7474; font-size:12px;" class="material-icons">timeline</i> ${this.formatThousands(prorateValue)}% <i style="color:#ee7474; font-size:16px;" class="material-icons">arrow_downward</i></span>`
          }
          else{
            htmlstr= `<span style=" color: #a4a4a4;"> - </span>` 
          }
        }
        else{
          prorateValue = ((value - preveousValue)/preveousValue)*100
          if(preveousValue == 0){
            prorateValue = 0
          }
          if(Math.floor(prorateValue)>0){
            prorateValue= Math.floor(prorateValue)
            htmlstr= `<span style=" color: #54b854;" class="value_hover" data-title="Up from ${this.formatThousands(preveousValue)} in the previous period" > ${this.formatThousands(prorateValue)}% <i style="color:#54b854; font-size:16px;" class="material-icons">arrow_upward</i></span>`
          }
          else if(Math.floor(prorateValue)< 0){
            prorateValue= Math.floor(prorateValue)
            htmlstr= `<span style=" color: #ee7474;" class="value_hover" data-title="Down from ${this.formatThousands(preveousValue)} in the previous period" > ${this.formatThousands(prorateValue)}% <i style="color:#ee7474; font-size:16px;" class="material-icons">arrow_downward</i> </span>`
          }
          else{
            prorateValue= Math.floor(prorateValue)
            htmlstr= `<span style=" color: #a4a4a4;"> - </span>  ` 
          }  
        } 
        return htmlstr
      } 
    }
  },
  watch: {
    currencyAED(newval) {
      if (newval) {
        this.fields[1][1].mapping = ["current","invoices_analytics", "invoices_sum_AED"]
        this.fields[3][1].mapping = ["current","payments_analytics", "payments_sum_kema_AED"]
        this.fields[2][1].mapping = ["current","payments_analytics", "payments_sum_AED"]
      }
      else {
        this.fields[1][1].mapping = ["current","invoices_analytics", "invoices_sum"]
        this.fields[3][1].mapping = ["current","payments_analytics", "payments_sum_kema"]
        this.fields[2][1].mapping = ["current","payments_analytics", "payments_sum"]
      }
      this.applyFilter();
    }
  }

};
</script>

<style lang="scss">
.kema-green {
  margin-right: auto;
  color: #737674;
  font-size: 14px;
}
@media (max-width: 991.98px) {
    .kema-green {
      font-size: 12px;
    }
}
.numeric {
  /* color: #73f3a9; */
  color: #000000;
  font-size: 28px;
  margin-left: -1rem;
}

.flex-break {
  height: 0;
  margin: 0;
  border: 0;
  width: 100%;
}

.search-results {
  width: 100%;
}

.business-list {
  overflow:auto;
  height: 20rem;
  z-index: 1;
  right: 0;
}

.business-input {
  position: relative;
  i {
    right: 12px;
    top: 12px;
    position: absolute;
  }
}

.custom-control {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.value_hover{
  vertical-align: bottom; 
  font-size: 16px; 
  font-weight: 600;
}
[data-title] {
  &:after {
    content: attr(data-title);
    font-family: $brand-font-light !important;
    font-size: 12px;
    text-align: left;
    line-height: 1.2em;
    background-color: #EBF5FE;
    border: 1px solid #AFE3F9;
    color: #0170ED;
    border-radius: 8px;
    position: absolute;
    padding: 5px;
    white-space: pre;
    opacity: 0;
    z-index: 99999;
    visibility: hidden;
    width: max-content;
    overflow: hidden;
    white-space: normal;
  }

  &:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.1s;
    visibility: visible;
    width: max-content;
    overflow: hidden;
    white-space: pre-line;
  }
}
@media (max-width: 600px) {
  [data-title] {
    &:after {
      width: fit-content;
    }
  
    &:hover:after {
      width: fit-content;
    }
  }
}
</style>